import React, { FC, ReactNode } from 'react';
import { formatClassName } from '../../utils';

export type Alignment = 'center' | 'justify' | 'left' | 'right';
export type Size = 'default' | 'large';

export interface Props {
  align?: Alignment;
  children: ReactNode;
  className?: string;
  size?: Size;
}

export const ExplainerText: FC<Props> = ({ align = 'left', children, className, size = 'default' }) => {
  return (
    <div
      className={formatClassName(['explainer-text', `${size}-explainer-text`, `${align}-explainer-text`, className])}
    >
      {children}
    </div>
  );
};
